const { feWp } = window;
const { addFilter } = feWp.hooks;

/* These settings ensure that slides are dragged one at a time, 
preventing them from being skipped during rapid dragging. */
const swiperDraggableSettings = {
  longSwipesRatio: 0,
  threshold: 0,
  touchRatio: 0.1,
};

const extendContentSliderSettings = ( defaultSliderSettings ) => ( {
  ...defaultSliderSettings,
  ...swiperDraggableSettings,
} );

addFilter( 'b3rg_tab_slider_content_extend', 'b3rg/slider', extendContentSliderSettings );
